export enum AccountGroupRole {
  IndependentPartner = 'independent partner',
  Partner = 'partner',
  Primary = 'primary',
  Secondary = 'secondary',
}
